import { LayoutState } from "./types";

export const initialLayout = {
    view : {
        cameras: [],
        cols: 0,
        rows: 0,
        name: ''
    },
    camerasIds: {},
    id: '',
    rows: 0,
    cols: 0,
    name: '',
    panes: [],
    camerasPositions: []
};

const initialView = {
    cameras: [
        {
            id: null,
            relative_position: {
                bottom: 1,
                left: 0,
                right: 1,
                top: 0
            }
        }],
    cols: 1,
    name: "Standart View 1 x 1",
    rows: 1
}

export const initialState : LayoutState = {
    initialView: initialView,
    initialCameras: [],
    openedLayoutList: false,
    currentLayout: initialLayout,
    currentLayoutType: 'Layer',
    currentLayoutChanged: false,
    checkedPane: null,
    expandedLayoutList: true,
    expandedVideoLayout: null,
    datePickerIsOpened: false,
    streamPanes: [],
    speedPickerIsOpened: false,
    exportAVIListOpened: false,
    exportStatusListOpened: false,
    exportShareStatusIsOpened: false,
    warningExceptionIsOpened: false,
    warningMessage: '',
    acknowledgeFormIsOpened: false,
    helpTableOpened: false,
    aboutTableOpened: false,
    isLoaded: true,
    exportWindowSize: {
        width: 570,
        height: 400
    },
    activeViewPosition: 0
};